/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect } from 'react';
import { vappContainer } from '@/application';
import { useTheme } from '../../../providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Col } from 'react-bootstrap';
//import { useHistory } from "react-router-dom";
import { useSMSignInUser } from '../machines/signInUser';
import toast from 'react-hot-toast';
//import { routes } from "../../../services/appNavigatorService/config/routes.config.json";
//import routes from "@AppNavigator/services/config/routes.config.json";
import { AppNavigatorService } from '@/AppNavigator';
//import { AppNavigatorService, SignInPageService } from "../../../services";
import { SignInPageService } from '@pages/SignIn/services';
import { useSMGetSignInPageGetContent } from '@pages/SignIn/machines/pageContent';
import {
  PageContainer,
  GoBackLink,
  Heading,
  Logo,
  FormComp,
  SubmitButton,
  OTPComp,
  SubHeading,
  ImageIcon,
  TopAuthorsWidget,
} from '../components';
import { useSMGetSignInType } from '@pages/SignIn/machines/getSignInType';
import { useSMSendOTP } from '@pages/SignIn/machines/sendOTP';
import { routes } from '@/AppNavigator/services/config/routes.config';

export const fillTemplate = (templateString, templateVariables) => {
  return templateString.replace(/\${(.*?)}/g, (_, g) => templateVariables[g]);
};

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.name);
};

const loginPageServ = () => {
  return vappContainer.get<AppNavigatorService>(AppNavigatorService.name);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  // let history = useHistory();
  //  const srv = getSrv()?.agent?.getStaticPageSync({});
  const { signInUserMachine, signInUserSend, signInUserState } =
    useSMSignInUser({});
  const { getSignInTypeState, getSignInTypeSend } = useSMGetSignInType({});
  const { sendOTPState, sendOTPSend } = useSMSendOTP({});
  const { signInPageGetContentState } = useSMGetSignInPageGetContent({});

  const staticPageContentConfig = getSrv()?.agent?.getStaticPageSync();

  useEffect(() => {
    let token = loginPageServ()?.getToken();
    if (token) {
      window.open(`${routes?.MyProfile?.path}`, '_self');
    }
  }, []);

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onIdentifierSubmit = (data: any) => {
    getSignInTypeSend('START', {
      payload: {
        email: data?.email,
      },
    });
  };

  const onLoginSubmit = (email: string, data: any) => {
    // console.log(`sign in user Click`, data);
    signInUserSend('START', {
      payload: {
        email: data.email,
        password: data.password,
        rememberMe: data.rememberMe,
      },
    });
  };

  const onOTPSubmit = (email: string, data: any) => {
    signInUserSend('START', {
      payload: {
        email: email,
        otp: data.otp,
      },
    });
  };

  const _handleResendClick = (email: string) => {
    sendOTPSend('START', {
      payload: {
        email: email,
      },
    });
  };

  const _onSignIn = (email: string, password: string, rememberMe: boolean) => {
    signInUserSend('START', {
      payload: {
        email: email,
        password: password,
        rememberMe: rememberMe,
      },
    });
  };

  const onRoleSelect = (token: string, role: any) => {
    signInUserSend('GET_ACCESS_TOKEN', {
      payload: {
        jwtToken: token,
        role: role?.uuid,
      },
    });
  };

  const _getSuccessNotification = () => {
    if (signInUserState?.matches('SIGN_IN_USER_SUCCESS')) {
      setTimeout(
        () => window.open(`${routes?.MyProfile?.path}`, '_self'),
        2000
      );
    }
  };
  const _getErrorNotification = () => {
    if (getSignInTypeState?.matches('GET_SIGN_IN_TYPE_FAILURE')) {
      toast.error(getSignInTypeState?.event?.data?.value);
    }
    if (signInUserState?.matches('SIGN_IN_USER_FAILED')) {
      //  log.blue(signInUserState?.event?.data);
      toast.error(signInUserState?.event?.data?.value);
    }
  };

  const _getPageContent = () => {
    if (
      signInPageGetContentState?.matches('GET_PAGE_CONTENT') ||
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE') ||
      signInUserState?.matches('GET_ACCESS_TOKEN') ||
      signInUserState?.matches('SIGN_IN_USER')
    ) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.GetPageLoading || {})}
        />
      );
    }

    if (signInUserState?.matches('RENDER_ACCOUNT_SELECTION')) {
      return (
        <Col md={12} xs={12}>
          <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
          <GoBackLink />
          <TopAuthorsWidget
            title={'Select your Account'}
            authors={signInUserState?.context?.signInRes?.userRoles}
            onRowClick={onRoleSelect.bind(
              null,
              signInUserState?.context?.signInRes?.signInToken
            )}
          />
        </Col>
      );
    }

    if (
      getSignInTypeState?.matches('GET_SIGN_IN_TYPE_SUCCESS') &&
      signInUserState?.nextEvents?.includes('START')
    ) {
      if (getSignInTypeState?.event?.data?.value?.signInType === 'password') {
        return (
          <Col xs={12} md={12}>
            <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
            <GoBackLink />
            <Heading
              title={staticPageContentConfig?.header?.identifier?.title}
            />
            <FormComp
              renderSubmitButton={renderSubmitButton}
              authType={'PASSWORD'}
              onFormSubmit={onLoginSubmit.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
              initialData={{
                email: getSignInTypeState?.event?.data?.value?.email,
              }}
            />
          </Col>
        );
      }
      if (getSignInTypeState?.event?.data?.value?.signInType === 'otp') {
        return (
          <Col md={4} xs={11}>
            <Logo logoURL={staticPageContentConfig?.header?.otp?.logo} />
            <GoBackLink />
            <Heading title={staticPageContentConfig?.header?.otp?.title} />
            <ImageIcon
              imageIconURL={staticPageContentConfig?.header?.otp?.iconURL}
              height={100}
            />
            <SubHeading
              subHeadingText={fillTemplate(
                staticPageContentConfig?.header?.otp?.subHeadingText,
                { email: getSignInTypeState?.event?.data?.value?.email }
              )}
            />
            <OTPComp
              renderSubmitButton={renderSubmitButton}
              onFormSubmit={onOTPSubmit.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
              onResendClick={_handleResendClick.bind(
                null,
                getSignInTypeState?.event?.data?.value?.email
              )}
            />
          </Col>
        );
      }
      return null;
    }

    if (
      signInPageGetContentState?.matches('RENDER_PAGE') &&
      getSignInTypeState?.nextEvents?.includes('START')
    ) {
      return (
        <Col xs={12} md={12}>
          <Logo logoURL={staticPageContentConfig?.header?.identifier?.logo} />
          <GoBackLink />
          <Heading title={staticPageContentConfig?.header?.identifier?.title} />
          <FormComp
            renderSubmitButton={renderSubmitButton}
            authType={'IDENTIFIER'}
            onFormSubmit={onIdentifierSubmit}
          />
        </Col>
      );
    }
  };
  return (
    <PageContainer>
      {_getSuccessNotification()}
      {_getErrorNotification()}
      {_getPageContent()}
    </PageContainer>
  );
};
